import { render, staticRenderFns } from "./PurchaseLabelDialog.vue?vue&type=template&id=d3586d26"
import script from "./PurchaseLabelDialog.vue?vue&type=script&lang=js"
export * from "./PurchaseLabelDialog.vue?vue&type=script&lang=js"
import style0 from "./PurchaseLabelDialog.vue?vue&type=style&index=0&id=d3586d26&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports